import styled, { css } from 'styled-components';
import { Button, Modal, Tag, Typography, Space } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, DeleteOutlined, BellOutlined } from '@ant-design/icons';

const BLUE_COLOR = '#2F54EB';

const BASE_BUTTON_STYLE = css`
	border-radius: 4px;
	font-weight: 400;
	font-size: 16px;
	height: 40px;
	max-height: 2rem;
	display: flex;
	align-items: center;
`;

export const CustomModal = styled(Modal)`
	.ant-modal-content {
		border-radius: 24px;

		.ant-modal-close {
			top: 15px;
			right: 15px;
		}
	}

	.ant-modal-header {
		border-radius: 24px 24px 0 0;
		padding: 32px;
	}

	.ant-modal-footer {
		padding: 32px;
	}
`;

export const ContentTag = styled(Tag)`
	margin-bottom: 8px;
	margin-right: 8px;
	font-size: 14px;
	padding: 4px 8px;
	border-radius: 4px;
	background-color: #ebeefd;
	color: #333;
	border: none;
`;

export const CustomTitle = styled(Typography.Text)`
	font-size: 25px;
	font-weight: 600;
	color: #262626;
	line-height: 32px;
`;

export const CustomSubtitle = styled(Typography.Text)`
	font-size: 18px;
	font-weight: 600;
	color: #262626;
	line-height: 24px;
`;

export const CustomText = styled(Typography.Text)`
	font-size: 18px;
	color: #262626;
`;

export const CancelButton = styled(Button)`
	${BASE_BUTTON_STYLE}
`;

export const PrimaryButton = styled(Button)`
	${BASE_BUTTON_STYLE}
	background-color: {${BLUE_COLOR}};
}
`;

export const Paragraph = styled(Typography.Paragraph)`
	text-align: center;
	margin: 0;
	width: 100%;
`;

export const SuccessIcon = styled(CheckCircleOutlined)`
	font-size: 48px;
	color: #17a93b;
`;

export const ErrorIcon = styled(CloseCircleOutlined)`
	font-size: 48px;
	color: #ff4d4f;
`;

export const DeleteOutlinedBig = styled(DeleteOutlined)`
	font-size: 48px;
	color: #d13342;
	margin-top: 16px;
`;

export const BellOutlinedBig = styled(BellOutlined)`
	font-size: 48px;
	color: #2f54eb;
	margin-top: 16px;
`;

export const CustomMessage = styled(Space)`
	text-align: center;
	color: #262626;
`;
